<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="dedication"><a id="page_5"></a><a id="page_6"></a><a id="page_7">It is as absurd to conceive of a wheat field with a single stem as it is to imagine just a single world in the vast universe.</a></p><a id="page_7">
<p class="dedication1">—M<span class="small">ETRODORUS</span>, <i>Epicurean philosopher of the third century BCE</i></p>
</a></div><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?22ca6d52